import React, { useEffect, useState } from "react";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";  // Import your configured axios instance
import './UsersList.css'; // Import the CSS file
import TopBar from "./TopBar";
import { Col, Container, Form, Row } from "react-bootstrap";
import { useShippingModes, useConsignmentTypes } from "../../utils/Utilities.js";
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { useRef } from "react";
import useAuth from "../../hooks/useAuth";

const ListCustomerRate = () => {
  const [rates, setRates] = useState([]); // To store list of rates
  const [loading, setLoading] = useState(false); // To show loading spinner while fetching
  const [error, setError] = useState(null); // To handle errors
  const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
  const ratesPerPage = 15; // Number of rates per page
  const axiosPrivate = useAxiosPrivate();
  const [customerType, setCustomerType] = useState("");
  const { auth } = useAuth();

  const navigate = useNavigate();

  const { shippingModes } = useShippingModes();
  const shippingModeMap = React.useMemo(() => {
    return shippingModes.reduce((acc, item) => {
      acc[item.shipping_mode] = item.description;
      return acc;
    }, {});
  }, [shippingModes]);



  const { consignmentTypes } = useConsignmentTypes();
  const consignmentTypeMap = React.useMemo(() => {
    return consignmentTypes.reduce((acc, item) => {
      acc[item.consignment_type] = item.description;
      return acc;
    }, {});
  }, [consignmentTypes]);





  useEffect(() => {
    if (!customerType) return; // only after dropdown selection

    const fetchRates = async () => {
      try {
        setLoading(true);

        const response = await axiosPrivate.get(
          // `api/admin/list-franchise-rates?franchise_id=${franchiseDbId}`,
          `api/list-customer-rates?customer_type=${customerType}&franchise_id=${auth.franchise_id},`,
          { withCredentials: true }
        );

        if (response.status === 204) {
          setRates([]); // IMPORTANT
          return;
        }

        setRates(response.data);
        setCurrentPage(1); // reset pagination on new selection
      } catch (error) {
        console.error("Error fetching rates:", error);
        setError("Failed to load rates");
      } finally {
        setLoading(false);
      }
    };

    fetchRates();
  }, [customerType]);


  const handleDeleteClick = async (rate_id) => {
    if (!window.confirm("Are you sure you want to delete this rate?")) {
      return;
    }

    try {
      await axiosPrivate.delete(
        `/api/delete-customer-rate?rate_id=${rate_id}`,
        { withCredentials: true }
      );

      setRates((prevRates) =>
        prevRates.filter((rate) => rate.id !== rate_id)
      );

      alert("Customer rate deleted successfully");

      // Reload page AFTER clicking OK
      window.location.reload();

    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message || "Error deleting Customer rate"
      );
    }
  };


  const handleEditClick = (rateId) => {
    navigate(`/update/customer_rate/${rateId}`);
  };

  // Paginate rates
  const safeRates = Array.isArray(rates) ? rates : [];

  const indexOfLastRate = currentPage * ratesPerPage;
  const indexOfFirstRate = indexOfLastRate - ratesPerPage;
  const customerRateList = safeRates.slice(
    indexOfFirstRate,
    indexOfLastRate
  );


  // Pagination handler
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Total pages needed for pagination
  const totalPages = Math.ceil(rates.length / ratesPerPage);







  return (
    <>
      {/* <Container> */}
      <section className="empbody">
        <div className="wrapperemp2">
          <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>

          <h3>Customer Rate List</h3>
          <Row>
            <Col>
              <div className="input-boxs">
                <label htmlFor="customerType">
                  Rate category
                  <sup>*</sup>
                </label>

                <select
                  id="customerType"
                  value={customerType}
                  onChange={(e) => setCustomerType(e.target.value)}
                  required
                  style={styles.input}
                  aria-describedby="customerTypeNote"
                >
                  <option value="" disabled>
                    Select Rate category
                  </option>
                  <option value="Franchise">Franchise Customer</option>
                  <option value="Customer">Individual Customer</option>
                  <option value="Common">Common</option>
                </select>
              </div>

            </Col>
          </Row>
          <table id="customers">
            <thead>
              <tr>
                {/* <th>Rate category/th> */}
                <th>Customer/Franchise name</th>
                <th>Shipping mode</th>
                <th>Consignment type</th>
                <th>Maximum weight</th>
                <th>Rate</th>
                <th>ab cost</th>
                <th>Surcharge perc</th>
                <th>State, District</th>
                <th>options</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(customerRateList) && customerRateList.length > 0 ? (
                customerRateList.map((rate) => (
                  <tr key={rate.id}>
                    {/* <td>{rate.customer_type}</td> */}
                    <td>{rate.customer_name}</td>

                    <td>{shippingModeMap[rate.shipping_mode] || rate.shipping_mode}</td>
                    <td>{consignmentTypeMap[rate.consignment_type] || rate.consignment_type}</td>
                    <td>{rate.max_weight}</td>
                    <td>{rate.rate}</td>
                    <td>{rate.ab_cost}</td>
                    <td>{rate.surcharge_perc}</td>
                    <td>{rate.state_name} - {rate.district_name}</td>
                    <td>
                      <button
                        type="button"
                        className="btn btn-warning button-space btn-ico"
                        onClick={() => handleEditClick(rate.rate_id)}
                      >
                        <i className="bx bxs-edit icon"></i>
                      </button>
                      <button type="button" className="btn btn-danger btn-ico"
                        onClick={() => handleDeleteClick(rate.rate_id)}
                      >

                        <i className="bx bxs-trash icon"></i>
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="11" style={{ textAlign: "center" }}>
                    No data available
                  </td>
                </tr>
              )}

            </tbody>
          </table>

          {/* Pagination - only show if there are multiple pages */}
          {totalPages > 1 && (
            <div className="pagination">
              {Array.from({ length: totalPages }, (_, index) => (
                <button
                  key={index}
                  onClick={() => handlePageChange(index + 1)}
                  disabled={currentPage === index + 1}
                >
                  {index + 1}
                </button>
              ))}
            </div>
          )}


        </div>
      </section>
      <TopBar />
      {/* </Container> */}

    </>
  );
};


const styles = {
  container: {
    padding: '40px',
    maxWidth: '500px',
    margin: 'auto',
    fontFamily: 'Arial, sans-serif',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
  },
  inputWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  input: {
    padding: '10px',
    fontSize: '16px',
    border: '1px solid #ccc',
    borderRadius: '4px',
  },
  dropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#fff',
    border: '1px solid #ccc',
    borderTop: 'none',
    maxHeight: '200px',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    margin: 0,
    boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
  },
  dropdownItem: {
    padding: '10px',
    cursor: 'pointer',
    borderBottom: '1px solid #eee',
  },
  button: {
    padding: '10px 15px',
    backgroundColor: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    fontSize: '16px',
    cursor: 'pointer',
  },


};

export default ListCustomerRate;
